import { useSelect } from 'downshift';
import { useTranslations } from '~/services/umbraco/hooks';
import { Text } from '~/shared/components/Text';
import {
    StyledChevron,
    StyledList,
    StyledListItem,
    StyledSelect,
    StyledText,
    StyledTextWrapper,
} from './styled';

type SelectProps = {
    data: number[];
    setPageSize: (newPageSize: number) => void;
    value: number;
};

export default function Select({ data, setPageSize, value }: SelectProps) {
    const { translate } = useTranslations();

    const {
        isOpen,
        selectedItem,
        getToggleButtonProps,
        getMenuProps,
        highlightedIndex,
        getItemProps,
    } = useSelect({
        items: data,
        initialSelectedItem: value,
        onSelectedItemChange: ({ selectedItem }) => {
            if (selectedItem !== null && selectedItem !== undefined) {
                setPageSize(selectedItem);
            }
        },
    });

    return (
        <StyledSelect>
            <StyledTextWrapper {...getToggleButtonProps()}>
                Vis
                <Text> {selectedItem}</Text>
                <StyledChevron style={{ transform: isOpen ? 'rotate(180deg)' : '' }} />
                <StyledText>{translate('mit-fog.orders.ordersPerPage')}</StyledText>
            </StyledTextWrapper>

            <StyledList {...getMenuProps()} style={{ display: !isOpen ? 'hidden' : 'block' }}>
                {isOpen &&
                    data.map((item, index) => (
                        <StyledListItem
                            key={item + index}
                            {...getItemProps({ item, index })}
                            highlighted={highlightedIndex === index}
                        >
                            {item}
                        </StyledListItem>
                    ))}
            </StyledList>
        </StyledSelect>
    );
}
